<template>
  <div class="automous">
    <div class="auto" style="height: 540px;">
      <!-- 自助提交 -->
      <div class="form-item-row" :class="{'error-border':errorObj.mobile}">
        <div class="ad-title"><span class="must-ad">*</span>联系方式</div>
        <div class="value"><input @input="errorObj.mobile = false" type="text" v-model="form.mobile" maxlength="30"
            placeholder="请输入手机号"></div>
      </div>
      <div v-if="errorObj.mobile" class="error-box">请输入手机号</div>

      <!-- <div class="form-item-row" :class="{'error-border':errorObj.depictSound}">
        <div class="ad-title"><span class="must-ad">*</span>语音描述</div>
        <div class="value form-item">
          <input @input="errorObj.depictSound = false" type="text" v-model="form.depictSound" maxlength="30"
            placeholder="请用语音简单描述您的需求" disabled="disabled" class="soundInput">
          <a class="sound" @click="recordSound">录音</a>
        </div>
      </div>
      <div v-if="errorObj.depictSound" class="error-box">请用语音简单描述您的需求</div> -->

      <div class="form-item-row f-column remark">
        <div class="ad-title width-100">需求描述</div>
        <textarea v-model="form.description" maxlength="200" placeholder=""></textarea>
        <div class="textarea-length"><span style="color:rgba(0,0,0,.85)">{{form.description.length}}</span>/200</div>
      </div>
      <div class="timeData" v-if="flag">
        {{ timeData }}
      </div>
      <!-- <div id="dome1">
        <div ref="box"></div>
      </div> -->
      <div class="soundList">
        <div class="element2" v-if="sound" @click="changsound"></div>
        <div class="element3" v-if="sound1" @click="changsound2"></div>
        <div class="element4" v-if="sound2"></div>
      </div>
    </div>
    <div class="form-item-button">
      <div v-if="sumitButton"><button @click="submitDemand">确认提交</button></div>
      <div class="flex-row" v-if="sound2">
        <div @click="reset">取消</div>
        <div @click="printFormValue">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { putRelease } from '@/api/userPerson/userPerson'
  import { connectWebViewJavascriptBridge } from '@/utils/OverallJsMobile'
  import { Row, Col, Checkbox, CheckboxGroup, RadioGroup, Radio,Toast, Notify, Popup, Picker} from 'vant'
  export default{
    data() {
      return{
        errorObj: {
          mobile: false,
          // depictSound:false
        },
        sumitButton:true,
        flag:false,
        sound:false,
        sound1:false,
        sound2:false,
        form:{
          // depictSound:'',//语音描述
          recordText:'',//录音转文字
          mobile:'',
          source:4,
          description:'',
          userId:'',
          versionnub:1//需求数据版本
        },
        timeData :'',
        fromParam: null  

      }
    },
    components: {
      Row,
      Col,
      Checkbox,
      CheckboxGroup,
      RadioGroup,
      Radio,
      Toast,
      Notify,
    },
    created() {
       this.form.userId = getCookie('accountId') || getCookie('AccountId')
       window.addEventListener('beforeunload', e =>this.test(e))
    },
    mounted() {
      const urlParams = new URLSearchParams(window.location.search);
      this.fromParam = urlParams.get('from');
    },
    destroyed() {
     window.removeEventListener('beforeunload', e => this.test(e))
    },
    methods:{
      test(e) {
        // 刷新关闭页面
        $HMD$.M.sendApp({
          name: 'recordAudio',
          value: 'cancel'
        })
      },
      timeCount() {
        // 正计时
        let tempTime = 0;
        let second = 0;
        let minute = 0;
        let hour = 0;
        this.timeData = "";
        this.timer = setInterval(() => {
             tempTime += 1;
             // hour = parseInt(tempTime%3600) ; // 转小时
             minute = parseInt(tempTime%3600/60); // 转分钟
             second = parseInt(tempTime%3600%60); // 转秒
             // 格式化
             // hour = (hour > 9 ? hour : "0" + hour) + "";
             minute = (minute > 9 ? minute : "0" + minute) + "";
             second = (second > 9 ? second : "0" + second) + "";

             this.timeData = minute + ":" + second;

             $HMD$.M.returnApp('recordError',function(data,send){
               if(data.msg=='录音初始化失败'){
                 Toast('抱歉，录音失败')
               }
             })
        }, 1000);
      },
      recordSound(){
        this.sound = true;
        this.sound1 = false;
        this.sound2 = false;
        this.flag = false;
      },
      reset(){
        // 取消
        $HMD$.M.sendApp({
          name: 'recordAudio',
          value: 'cancel'
        })
        this.sound = false;
        this.sound1 = false;
        this.sound2 = false;
        this.flag = false;
        this.sumitButton = true;
      },
      changsound(){
        this.sound = false;
        this.sound2 = false;
        this.sound1 = true;
        if(this.sound1){
          let _this = this
          $HMD$.M.Ready(function () {
            // 录音开始发送消息
            $HMD$.M.sendApp({
              name: 'recordAudio',
              value: 'started'
            })
            $HMD$.M.returnApp('recordStart',function(data,send){
              _this.timeCount();
            })
          })
        }
        this.flag = true;
      },
      changsound2(){
        this.sound = false;
        this.sound2 = true;
        this.sound1 = false;
        this.flag = true;
        this.sumitButton = false;
        clearInterval(this.timer)
        if(this.sound2){
          let _this = this
          $HMD$.M.sendApp({
            name: 'recordAudio',
            value: 'end'
          })
          $HMD$.M.returnApp('recordFinish',function(data,send){
            // alert(data)
            // _this.$refs.box.innerHTML = data.recordUrl
            _this.form.depictSound = data.recordUrl
            _this.form.recordText = data.recordText
             // alert(`data:${data}`)
          })
          //$HMD$.M.returnApp('recordFinish',function(data,send){

             // _this.$refs.box.innerHTML = data.recordUrl
             // _this.form.depictSound = data.recordUrl
          //})
        }
        // connectWebViewJavascriptBridge(function (bridge) {
        //   bridge.registerHandler('callHDBridgeHandler', function (message, responseCallback) {
        //     let jsonMessage = JSON.parse(message)
        //     this.$refs.box.innerHTML = message
        //     this.$refs.boxs.innerHTML = responseCallback
        //     if (typeof (jsonMessage.name) !== 'undefined' && jsonMessage.name === 'recordFinish') {
        //        // 接收录音结束返回值
        //         // document.write(responseCallback)

        //     }
        //   })
        // })
      },
      // 提交
      printFormValue(){
        this.sumitButton = true;
        this.sound = false;
        this.sound2 = false;
        this.sound1 = false;
        this.flag = false;
        this.submitDemand();
      },
      //提交
      submitDemand(){
        if (!this.form.mobile || this.form.mobile === '') {
          this.errorObj.mobile = true
          return
        }
        if (this.form.mobile) {
          const reg = /^(((0\d{2,3}-|0\d{2,4})\d{7,8})|(1[34578]\d{9})|(400-[0-9]{0,7}-[0-9]{1,7}))$/
          if (!reg.test(this.form.mobile)) {
            Toast('请输入正确的联系电话')
            return
          }
        }
        // if(!this.form.depictSound || this.form.depictSound === ''){
        //   this.errorObj.depictSound = true
        //   return
        // }
        putRelease(this.form).then(res => {
          console.log(res);
          if(res.data.code==200){
            this.$toast.success('提交成功')
            setTimeout(() => {
              if (this.fromParam === 'solution') {
                window.location.href = 'https://appsolution.fat.homedo.com/#/pages/send/index';
              } else {
                this.$router.push('/index.html')
              }
              
            }, 1000)
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .automous{
    min-height: calc(100vh - 120px) ;
    background: #fff;
    height:100%;
  }
  .form-item-row {
    display: flex;
    align-items: center;
    width: 344px;
    margin: 0 auto;
    color: rgba(0, 0, 0, 0.65);
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);

    &.error-border {
      border-bottom: 1px solid #FF3030;
    }

    &.f-column {
      flex-direction: column;
    }

    .time-z-tips {
      margin-right: 14px;
    }

    .time-pr {
      color: rgba(0, 0, 0, 0.25);
    }

    .check-arrow-btn {
      width: 24px;
      height: 24px;
      position: absolute;
      bottom: 16px;
      right: 4px;
      font-size: 20px;
      pointer-events: none;
    }

    .item-limit {
      display: inline-block;
      width: 28%;
      height: 100%;
      color: #409EFF;
      font-size: 14px;
    }

    .sys-flex-box {
      display: flex;
      width: 100%;
      position: relative;
      align-items: center;
      padding-bottom: 16px;
    }

    .item-box {
      width: 72%;
      height: 24px;
      background-color: #ffffff;
      overflow: hidden;

      .system {
        display: inline-block;
        color: #2F7BFF;
        border: 1px solid #2F7BFF;
        background: rgba(47, 123, 255, 0.1);
        border-radius: 4px;
        padding: 0 4px;
        height: 24px;
        line-height: 22px;
        margin: 0 8px 12px 0;
        box-sizing: border-box;
      }

    }
  }
  .flex-box {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .width-100 {
    width: 100% !important;
  }
  .remark{
    padding: 0 23px;
    width: 100%;
    box-sizing: border-box;
    border: none;
  }
  .form-item {
    &-banner {
      img {
        vertical-align: middle;
        width: 100%;
      }
    }

    &-row {
      .ad-title {
        background-color: #FFF;
        height: 50px;
        line-height: 50px;
        font-size: 15px;
        color: #000000;
        width: 85px;
        white-space: nowrap;
        display: flex;
        align-items: center;
        line-height: 1;

        .must-ad {
          color: #FF0000;
          padding-top: 4px;
          display: block;
          margin-right: 4px;
          font-size: 16px;
        }
      }

      .value {
        flex: 1;
        height: 50px;
        line-height: 50px;
        position: relative;

        input {
          width: 100%;
          font-size: 14px;
          border: none;
        }
      }

      textarea {
        width: 100%;
        height: 73px;
        font-size: 16px;
        border: none;
        resize: none;
        vertical-align: middle;
        background: #F8F9FB;
        padding-top: 10px;
        text-indent: 10px;
      }

      .textarea-length {
        font-size: 13px;
        text-align: right;
        width: 100%;
        line-height: 1;
        padding: 16px 0;
        color: rgba(0, 0, 0, .25);
        background: #F8F9FB;
        padding-right: 12px;
        box-sizing: border-box;
      }

      .checkbox-row {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 100%;
        color: rgba(0, 0, 0, 0.45);
        font-size: 13px;

        &-item {
          display: flex;
          align-items: center;
          text-align: center;
          justify-content: center;
          width: 80px;
          height: 24px;
          line-height: 22px;
          box-sizing: border-box;
          margin-right: 8px;
          margin-bottom: 16px;
          border: 1px solid rgba(0, 0, 0, 0.25);
          border-radius: 5px;

          &.active {
            border: 1px solid #2f7bff;
            color: #2F7BFF;
            background: rgba(47, 123, 255, 0.10);
          }

          &:last-child {
            margin-right: 0;
          }
        }

        .check-all-item {
          height: 24px;
          padding-bottom: 16px;
          margin-right: 20px;
          font-size: 15px;
          color: rgba(0, 0, 0, 0.85);
          display: flex;
          align-items: center;

          div {
            margin-left: 8px;
          }

          &:nth-of-type(4n) {
            margin-right: 0;
          }
        }
      }

      .checkbox-row-item-more:last-child .check-all-item {
        margin-right: 0;
      }
    }

    &-button {
      width: 344px;
      margin: 16px auto 0;

      button {
        width: 100%;
        border: none;
        height: 44px;
        background-color: #2f7bff;
        border-radius: 4px;
        font-size: 18px;
        color: #FFF;
      }
    }
  }
  .form-item-button{
    width: 90%;
   //  position: fixed;

   //  bottom:22px;
   //  left: 50%;
   //  margin-left:-45%;
  }
  .form-item{
    position: relative;
    .sound{
      position: absolute;
      right: 0;
      top: 0;
      margin-top: 13px;
      display: block;
      width: 78px;
      height: 24px;
      line-height: 26px;
      text-align: center;
      color: #fff;
      background: #2177FF;
      border-radius: 24px;
      font-size: 12px;
    }
  }
  .error-box {
    height: 0.666667rem;
    line-height: 0.666667rem;
    font-size: 0.32rem;
    color: #FF3030;
    width: 9.146667rem;
    margin: 0 auto;
  }
 .soundList{
   margin-left: 154px;
   margin-top: 30px;
 }
 .element2{
   width: 68px;
   height: 68px;
   background-color: #E40E0E;
   border-radius: 50%;
}
.element2:after{
   content: "";
   display: block;
   width: 45px;
   height: 45px;
   border-radius: 50%;
   background-color: #fff;
   position: relative;
   top: 11px;
   left: 11px;
}
 .element3,.element4{
   width: 68px;
   height: 68px;
   background-color: #FFEAEA;
   border-radius: 50%;
}
.element3:after{
   content: "";
   display: block;
   width: 30px;
   height: 30px;
   border-radius: 2px;
   background-color: #E40E0E;
   position: relative;
   top: 19px;
   left: 19px;
}
.element4:after{
    content: "";
    display: block;
    position: relative;
    top: 13px;
    left:26px;
    height: 0;
    width: 0;
    border: 20px solid transparent;
    border-left: 20px solid #E40E0E;
}
.timeData{
  width: 100%;
  text-align: center;
  font-size: 28px;
  color: #666666;
  padding-top: 30px;
}
.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  background: #fff;
  height: 100px;
}
.flex-row div {
  width: 142px;
  height: 44px;
}
.flex-row div:nth-child(1) {
  background: rgba(202, 202, 202, 1);
  color: #fff;
  font-size: 16px;
  line-height: 44px;
  text-align: center;
  border-radius: 10px;
}
.flex-row div:nth-child(2) {
  background: rgba(46, 123, 255, 1);
  color: #fff;
  font-size: 16px;
  line-height: 44px;
  text-align: center;
  border-radius: 10px;
}
.soundInput{
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/autonomous.vue